/**
 * @file Memory Mate (2 photos Collage) preview template.
 */

import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import classNames from 'classnames';

import { sortArrayByKey } from '../../../util/sorting';
import { IMAGE_SIZE_CODE } from '../../../constants/image-size-codes';
import ProgressivePhoto from '../../grid/ProgressivePhoto';

const propTypes = {
  collage: PropTypes.shape({
    id: PropTypes.string,
    photos: PropTypes.shape({
      records: PropTypes.arrayOf(
        PropTypes.shape({
          position: PropTypes.number,
          photo: PropTypes.shape({
            thumbnail_urls: PropTypes.array,
          }),
          asset_image: PropTypes.shape({
            url: PropTypes.string,
          }),
        }),
      ),
    }),
    custom_print: PropTypes.shape({
      background_image: PropTypes.shape({
        url: PropTypes.string,
      }),
      account: PropTypes.shape({
        logo_image: PropTypes.shape({
          url: PropTypes.string,
        }),
      }),
    }),
  }),
  className: PropTypes.string,
};

const MemoryMatePreviewTemplate = ({ collage, className }) => {
  const photoRecords = get(collage, 'photos.records', []);
  const sortedPhotoRecords = sortArrayByKey(photoRecords, 'position');
  const backgroundImageUrl = collage.custom_print.background_image?.url;

  const classes = classNames({
    'memory-mate-preview-template': true,
    [className]: !!className,
  });

  return (
    <div
      className={classes}
      style={{
        backgroundImage: backgroundImageUrl
          ? `url(${backgroundImageUrl})`
          : undefined,
      }}
    >
      {sortedPhotoRecords.map(record => (
        <div className="custom-print-memory-mate-photo" key={record.id}>
          <ProgressivePhoto
            key={record.photo.id}
            thumbnails={record.photo.thumbnail_urls}
            size={IMAGE_SIZE_CODE.MEDIUM2X}
            progressive
            alt=""
          />
        </div>
      ))}
      <span className="custom-print-memory-mate-identity-name">Your Name</span>
    </div>
  );
};

MemoryMatePreviewTemplate.propTypes = propTypes;

export default MemoryMatePreviewTemplate;
